import userNotification from "@/http/requests/userNotification"

export default {
  fetch({ commit }, userId) {
    return new Promise((resolve, reject) => {
      userNotification.fetch(userId).then(response => {
        commit('SET_USER_NOTIFICATIONS', response.data.data.userNotifications)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  read({ commit }, userNotificationId) {
    return new Promise((resolve, reject) => {
      userNotification.read(userNotificationId).then(response => {
        commit('READ_USER_NOTIFICATION', userNotificationId)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  }
}
